import React from "react";
import MainTemplate from "../components/template/MainTemplate";
import PBLGroupChattingPopupContainer from "../containers/PBLGroupChattingPopupContainer";

const PBLGroupChatListPage = ({ browserType, cookies, routeProps }) => {
    return (
        <MainTemplate>
            <PBLGroupChattingPopupContainer
                browserType={browserType}
                routeProps={routeProps}
                cookies={cookies}
            />
        </MainTemplate>
    );
};

export default PBLGroupChatListPage;